import React from 'react';
import styles from '../styles/ConfirmDeleteModal.module.scss';

export default function ConfirmDeleteModal({ roomName, onConfirm, onCancel }) {
    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <h5 className={styles.title}>Удалить?</h5>
                <p className={styles.message}>
                    Вы уверены, что хотите удалить <strong>"{roomName}"</strong>?
                </p>
                <div className={styles.buttons}>
                    <button className="btn btn-danger" onClick={onConfirm}>
                        Удалить
                    </button>
                    <button className="btn btn-secondary" onClick={onCancel}>
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    );
}
